import type { ThirdPartyProvidersFeatureConfig } from '../type';

export const thirdPartyProviders: Partial<ThirdPartyProvidersFeatureConfig> = {
    oidcReady: true,
    alternateHandoverTargetClientId: 'urn:cz:csas:mep:proxyAppSso',
};
